import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { Calendar } from '@mantine/dates';
import { t } from 'i18next';
import { X } from 'tabler-icons-react';

function DayCalendar({ handleDateChanged, attrName }) {
  const internalHandleDateChanged = (selectedDate) => {
    handleDateChanged(null, attrName, selectedDate);
  };

  return (
    <Group position="center">
      <Calendar
        firstDayOfWeek="monday"
        withCellSpacing={false}
        onChange={internalHandleDateChanged}
      />

      <ActionIcon
        size="xs"
        variant="subtle"
        aria-label="Vider"
        onClick={() => {
          handleDateChanged?.(null, attrName, null);
        }}
      >
        <Tooltip label={t('app.clear_value')}>
          <X size={14} />
        </Tooltip>
      </ActionIcon>
    </Group>
  );
}
export default DayCalendar;
